import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'
import { styled, css, ThemeProvider } from '@mui/material'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import { useMyStore } from '@hooks/useMyStore'
import { lockBodyScroll, unlockBodyScroll } from '@helpers/bodyscroll'
import StoreMap from '../store-map'

const StyledCloseButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  zIndex: 1,
  top: '5px',
  right: '5px',
  backgroundColor: 'rgba(0, 0, 0, 0.4)',
  color: 'white',
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
  },
}))

const StyledModal = styled(Modal)(({ theme }) => ({
  overflow: 'hidden !important',
  '.ReactModal__Content': {
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '50%',
    },
  },
}))

const StyledMapContainer = styled('div')(({ theme }) => ({
  width: '100%',
  top: '0',
  bottom: '0',
  right: '0',
  maxWidth: '954px',
  border: 'none',
  borderRadius: '0',
  position: 'absolute',
  backgroundColor: 'white',
  [theme.breakpoints.up('md')]: {
    width: '70%',
  },
}))

const MyStoreModalLocator = ({ isOpen, onClose, productInStore }) => {
  const { allStrapiStores, myStore, relatedStores } = useMyStore()

  useEffect(() => {
    lockBodyScroll()
    return () => unlockBodyScroll()
  }, [])

  return (
    <StyledModal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="My Store"
      className="reset-default-styles"
      ariaHideApp={false}
      closeTimeoutMS={500}
      overlayClassName="my-store-modal-overlay"
      style={{
        overlay: {
          overflow: 'hidden !important',
          backgroundColor: 'rgba(0, 0, 0, 0.75)',
          position: 'fixed',
          zIndex: 10000,
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
        },
      }}
    >
      <StyledCloseButton color="primary" aria-label="close modal" onClick={onClose} size="large">
        <CloseIcon />
      </StyledCloseButton>
      <StyledMapContainer>
        <StoreMap
          storeLocations={allStrapiStores}
          productInStore={productInStore}
          myStore={{ ...myStore, relatedStores }}
          isMyStore
        />
      </StyledMapContainer>
    </StyledModal>
  )
}

MyStoreModalLocator.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  productInStore: PropTypes.string,
}

export default MyStoreModalLocator
